<template>
  <div v-if="dialogs.length">
    <component
      :is="dialog.contents"
      v-for="(dialog, index) in dialogs"
      :key="index"
    />
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'Dialogs',
  computed: {
    ...mapState({
      dialogs: state => state.appFrame.dialogs,
    }),
  },
}

</script>
